var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-OrderFlow3C"},[(_vm.showAddToCartButton)?_c('AddToCartBtn'):_c('EditorBtn',{attrs:{"event-action":_vm.eventAction,"event-label":_vm.eventLabel,"analytics-value":"orderFlow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }